const DashboardShell = ({ title, subtitle, children }) => (
  <div>
    <header className="mb-8">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-500">{subtitle}</p>}
    </header>
    {children}
  </div>
);

export default DashboardShell;
